import {useTranslation} from 'react-i18next';

import {Badge} from '@/components/ui/badge';
import type {GetAllCurrentResidentsQuery} from '@/services/graphqlHooks';
import {ResidentStatus} from '@/services/graphqlHooks';

import useEvacuationStore from '../stores/evacuationStore';
import {formatPersonName} from '../utils/evacuationHelpers';
import EvacuationPersonRow from './EvacuationPersonRow';

type EvacuationResidentRowProps = {
  resident: GetAllCurrentResidentsQuery['getAllCurrentResidents'][number];
  roomLabel?: string;
};

const EvacuationResidentRow = ({
  resident,
  roomLabel,
}: EvacuationResidentRowProps) => {
  const {t} = useTranslation();
  const viewMode = useEvacuationStore(s => s.viewMode);
  const conditions = resident.conditions?.join(', ');

  return (
    <EvacuationPersonRow
      personId={resident.id}
      name={formatPersonName(resident.name)}
      details={[
        viewMode === 'list' && `${t('Room')}: ${roomLabel ?? t('No room')}`,
        conditions && `${t('Conditions')}: ${conditions}`,
      ]
        .filter(Boolean)
        .join(' · ')}
      badge={
        resident.status === ResidentStatus.Absent && (
          <Badge variant="outlined" color="warning">
            {t('Absent')}
          </Badge>
        )
      }
    />
  );
};

export default EvacuationResidentRow;
